package org.vreo.devicehub.navigation.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

import androidx.navigation3.runtime.NavKey
import androidx.savedstate.serialization.SavedStateConfiguration
import org.vreo.devicehub.features.core.domain.device.device.DeviceAuthentication
import org.vreo.devicehub.features.userAuthentication.domain.UserRole


sealed interface MainNavigationKey : NavKey {
    // Login/sign-in
    @Serializable
    data object Login : MainNavigationKey

    // Forget/reset password
    @Serializable
    data object ForgetPassword : MainNavigationKey

    // New user registration
    @Serializable
    data object NewUserRegistration : MainNavigationKey

    // New user account verification
    @Serializable
    data class NewUserVerification(val email: String, val validUntil: Long) : MainNavigationKey

    // Device list
    @Serializable
    data class DeviceList(val authenticationToken: String, val userRole: UserRole) : MainNavigationKey

    // Add/Link device to user account
    @Serializable
    data class AddDeviceToAccount(val authenticationToken: String) : MainNavigationKey

    @Serializable
    data class RegisterNewDevice(val authenticationToken: String) : MainNavigationKey

    @Serializable
    data class DeviceManagement(val authentication: DeviceAuthentication, val userRole: UserRole) : MainNavigationKey

    companion object {
        // Creates the required serialization configuration for open polymorphism
        val config = SavedStateConfiguration {
            serializersModule = SerializersModule {
                polymorphic(NavKey::class) {
                    subclass(Login::class, Login.serializer())
                    subclass(ForgetPassword::class, ForgetPassword.serializer())
                    subclass(NewUserRegistration::class, NewUserRegistration.serializer())
                    subclass(NewUserVerification::class, NewUserVerification.serializer())
                    subclass(DeviceList::class, DeviceList.serializer())
                    subclass(AddDeviceToAccount::class, AddDeviceToAccount.serializer())
                    subclass(RegisterNewDevice::class, RegisterNewDevice.serializer())
                    subclass(DeviceManagement::class, DeviceManagement.serializer())
                }
            }
        }
    }
}